import React, { useContext } from "react";
import styled from "styled-components";
import { UserSettingsContext } from "../context/userSettings";
import { rgba } from "../styles/stylesTheme";
import { borderRadius } from "../styles/stylesUtils";
import { getCSSImageUrl } from "../utils/mediaUrl";

const ThemeToggle = () => {
    const { theme, setTheme } = useContext(UserSettingsContext);

    return (
        <ThemeToggleStyles>
            <div className="toggle-slider" data-active={theme}></div>
            <button
                className={`toggle-option light ${
                    theme === "light" ? "active" : ""
                }`}
                onClick={() => setTheme("light")}
            ></button>
            <button
                className={`toggle-option dark ${
                    theme === "dark" ? "active" : ""
                }`}
                onClick={() => setTheme("dark")}
            ></button>
        </ThemeToggleStyles>
    );
};

const ThemeToggleStyles = styled.div`
    display: flex;
    position: relative;
    width: calc(100% - 0.8em);
    background: ${({ theme }) => rgba(theme, "colorUI", 0.8)};
    overflow: hidden;
    ${borderRadius(0.5)};
    margin: 0.4em;
    height: 3em;
    text-align: center;
    backdrop-filter: blur(1em);
    -webkit-backdrop-filter: blur(1em);

    .toggle-slider {
        position: absolute;
        top: 0.2em;
        bottom: 0;
        left: 0;
        background: ${({ theme }) => rgba(theme, "gradL", 1)};
        ${borderRadius(0.38)};
        width: 50%;
        height: calc(100% - 0.4em);
        transition: transform 0.2s ease-out;
        box-shadow: 0 0.05em 0.1em 0 rgba(0, 0, 0, 0.1);
    }

    .toggle-slider[data-active="light"] {
        transform: translateX(0.2em);
    }

    .toggle-slider[data-active="dark"] {
        transform: translateX(calc(100% - 0.2em));
    }

    .toggle-option {
        flex: 1;
        position: relative;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        z-index: 1;
        height: 100%;
        box-shadow: none;

        &:before {
            content: "";
            position: absolute;
            background: ${({ theme }) => rgba(theme, "black", 1)};
            top: calc(50%);
            left: calc(50%);
            transform: translate(-50%, -50%);
            width: 1.2em;
            height: 1.2em;
            mask: url("${getCSSImageUrl("img/theme-light.svg")}") no-repeat center center;
            -webkit-mask: url("${getCSSImageUrl("img/theme-light.svg")}") no-repeat center center;
            mask-size: 100%;
            -webkit-mask-size: 100%;
        }

        &.dark {
            &:before {
                left: calc(50% - 0.1em);
                mask: url("${getCSSImageUrl("img/theme-dark.svg")}") no-repeat center center;
                -webkit-mask: url("${getCSSImageUrl("img/theme-dark.svg")}") no-repeat center center;
                mask-size: contain;
                -webkit-mask-size: contain;
            }
        }

        &:hover {
            opacity: 0.8;
        }

        &.active {
            &:hover {
                opacity: 1;
            }
        }
    }

    .toggle-option.active {
        color: white;
    }
`;

export default ThemeToggle;
